var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaff4E(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 57.67 175.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#512a0b;}.cls-2{fill:#f3b792;}.cls-3{fill:#14adb2;}.cls-4{fill:#232323;}.cls-5{fill:#004568;}.cls-6{fill:#0e5279;}.cls-7{fill:#1199a1;}.cls-8{fill:#07253f;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "Staff_Female_01a",
    "data-name": "Staff_Female_01a",
    viewBox: "0 0 57.67 175.41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.87,7.65C7,7,5.88,28.44,6.05,31.43s.33,8.81.33,8.81l9.81-.5s-3-8.14-3-14.8S11.87,7.65,11.87,7.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.29,73.33C48,76.16,48,81.64,48,81.64s1.33,5.16,2.16,5,.67-3.82.67-3.82,1.49,7.81,2.49,7.81,3.22-.56,4-1.66c1.16-1.66-.5-7-.83-8.31s-7.32-10-7.32-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.58,31.19c1,2.26,1.86,16.48,4.05,21.69,4.09,9.75,8.88,19.42,9.64,20.62,1.17,1.82-3.16,5.32-5.32,3.32S37.31,62,36,57.87,28.17,35,28.67,30C29.19,24.88,36.27,25.74,38.58,31.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M29.82,151.32c-.35,1.54-1.21,4.63-.77,7.43.2,1.28,2.92,1.57,5.92,2.42,3.55,1,7.56,2.5,9.11,2.62,2.86.22,7.05-1.36,3.25-4.33s-10.39-8.84-10.39-8.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13.61,162.23c-.2,5.84-.15,12.78,4.16,13.14,4,.33,4.82-1,4.82-6.49s.42-7.11,0-10.31c-.34-2.49-2.66-2.82-4.49-3S13.77,157.24,13.61,162.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M41.5,78.32s1,8,.22,21.61-2,24.61-2.21,30.43-.52,18.29-.62,21.12-8.68,5-9.14,0S28.48,128,28.29,120.55s-3-26.44-3.43-29.76-1.18-13.47-1.18-13.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M30.74,84.56c-2.33,20.79-4.49,35.09-5,42.74s-2.82,29.26-2.82,32.42-9.81,6.48-10.15-.5-1-18.29-.83-24.77,2-12.81,1.83-16.47S9,88.39,9.63,81.74l.66-4.16,20.12.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M21.08,26.56c5.66-2.16,13.73-2.45,17.06,5.87s3.65,10.8,3.82,12.8-3.33,3.66-3.49,5.32-.5,12.64,0,15.3,3.32,10.14,4,14.46A49.38,49.38,0,0,1,43.12,87s-8.83,4.5-13.62,5.16c-4,.56-15.82-.14-20.64-2.8-.17-6.61,2.64-17.14,2.31-22.13s-3.8-18.6-3.63-28.08S12.82,29.71,21.08,26.56Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "15.46 45.39 34.15 47.23 31.65 74.83 12.49 72.14 15.46 45.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.35,27.94l1-4.33C16,22.62,12.86,20,13,13.8S18.52,2,24.5,2s10.14,3,10.31,9.48.17,11.8-1.66,12.3a13.23,13.23,0,0,1-4.33.17s-.49,4.49-.66,6.81S18.52,32.59,18.35,27.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.84,13.8c-1.16-1.49-3.65-.33-3.65,2.33s1.16,4.49,2.82,4.49c0,0,1,.17-.66,3S11.7,21.45,10.7,13.8,16.69.17,23.5,0s11.64,5,12,7.49S27.16,13.64,23,10.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.33,61.69l3.33-2.83L33,57.7c.83,1-1,2.66-1,2.66s2.83-.17,3.16,1a10.66,10.66,0,0,1,0,5.15c-.5,1.5-6,2-7.31,2s-9.65-2.66-9.65-2.66l1.17-6.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.7,31.26c-5,0-9.15,18.79-9.48,22.62s-.66,7.81,2,9,16,4.49,19.62,5.16,4.49-6.15.83-7.48-13.8-4.16-13.8-4.16C12,45.4,18.9,31.26,9.7,31.26Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vask_Sterilisation",
    "data-name": "Vask & Sterilisation"
  }, /*#__PURE__*/React.createElement("use", {
    width: 57.67,
    height: 175.41,
    transform: "matrix(-1, 0, 0, 1, 57.67, 0)",
    xlinkHref: "#Staff_Female_01a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff4E);
export default __webpack_public_path__ + "static/media/staff-4-e.9f5b0d78d87edc39a24dffa24bcb466b.svg";
export { ForwardRef as ReactComponent };